export const styles = {
  container: {
    width: "100%",
    maxWidth: "260px",
    height: "450px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  overlay: {
    height: "100%",
    width: "100%",
  },
  inner: {
    height: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
  },
  top: {
    display: "flex",
    flexDirection: "column",
    height: "180px",
    justifyContent: "center",
    alignItems: "center",
  },
  new: {
    color: "#fff",
    fontSize: "20px",
    marginBottom: "10px",
  },
  heading: {
    color: "#FFF",
  },
  detail: {
    color: "#FFF",
    fontSize: "14px",
  },
  goDetail: {
    display: "flex",
    justifyContent: "center",
  },
  link: {
    textAlign: "center",
    color: "#fff",
    fontSize: "14px",
  },
  icon: {
    color: "#fff",
    paddingBottom: "5px",
  },
};
